export default[
    {
        path: '/dataList/achievement',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '门店业绩',
            authLogin: true
        }
    }
]